import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
// 第一題
import stepHome from '@/components/step1/index'
import step1question from '@/components/step1/question'
import step1Flow from '@/components/step1/flow'
// 第二題
import step2Home from '@/components/step2/index'
import step2question from '@/components/step2/question'
import step2Flow from '@/components/step2/flow'
// 第三題
import step3Home from '@/components/step3/index'
import step3question from '@/components/step3/question'
import step3Flow from '@/components/step3/flow'
// 第四題
import step4Home from '@/components/step4/index'
import step4question from '@/components/step4/question'
import step4Flow from '@/components/step4/flow'
// 第五區域
import page1 from '@/components/step5/page1'
import page2 from '@/components/step5/page2'
import page3 from '@/components/step5/page3'
import page4 from '@/components/step5/page4'
import page5 from '@/components/step5/page5'
import page6 from '@/components/step5/page6'
import page7 from '@/components/step5/page7'
import page8 from '@/components/step5/page8'

Vue.use(Router)

// 確定路徑
function pathMode () {
  const loc = location
  const host = 'http://' + loc.host
  const href = loc.href.replace(host, '')
  return 'hash'
  // return href.split('/').indexOf('chance') < 0 ? 'history' : 'hash'
}

export default new Router({
  mode: pathMode(), // history | abstract | hash(預設值)
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/index',
      name: '歡迎頁',
      component: home
    },
    {
      path: '/step1',
      name: '第一題',
      component: stepHome
    },
    {
      path: '/step1-1',
      name: '第一題題目',
      component: step1question
    },
    {
      path: '/step1-2',
      name: '第一題流程',
      component: step1Flow
    },
    {
      path: '/step2',
      name: '第二題',
      component: step2Home
    },
    {
      path: '/step2-1',
      name: '第二題題目',
      component: step2question
    },
    {
      path: '/step2-2',
      name: '第二題流程',
      component: step2Flow
    },
    {
      path: '/step3',
      name: '第三題',
      component: step3Home
    },
    {
      path: '/step3-1',
      name: '第三題題目',
      component: step3question
    },
    {
      path: '/step3-2',
      name: '第三題流程',
      component: step3Flow
    },
    {
      path: '/step4',
      name: '第四題',
      component: step4Home
    },
    {
      path: '/step4-1',
      name: '第四題題目',
      component: step4question
    },
    {
      path: '/step4-2',
      name: '第四題流程',
      component: step4Flow
    },
    {
      path: '/step0',
      name: '第五題區域1',
      component: page1
    },
    {
      path: '/step5-1',
      name: '第五題區域2',
      component: page2
    },
    {
      path: '/step5-2',
      name: '第五題區域3',
      component: page3
    },
    {
      path: '/step5-3',
      name: '第五題區域4',
      component: page4
    },
    {
      path: '/step5-4',
      name: '第五題區域5',
      component: page5
    },
    {
      path: '/step5-5',
      name: '第五題區域6',
      component: page6
    },
    {
      path: '/step5-6',
      name: '第五題區域7',
      component: page7
    },
    {
      path: '/step5-7',
      name: '第五題區域8',
      component: page8
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js